import {isNilOrEmpty} from 'ramda-adjunct';

import {useGetTireOrderQuery} from '@dms/api/core';

export function useTaskRelationTireOrder(tireOrderId: string) {
  const {
    data: tireOrder,
    isLoading: isTireOrderLoading,
    isError: isTireOrderError,
  } = useGetTireOrderQuery({orderId: tireOrderId}, {skip: isNilOrEmpty(tireOrderId)});

  return {
    tireOrder,
    customerId: tireOrder?.customerId,
    isLoading: isTireOrderLoading,
    isError: isTireOrderError,
  };
}
